module.exports = __webpack_public_path__ + "img/library4.5195ea44.png";